// Notification sound utility with distinct sounds
export function playNotificationSound(type = 'payin') {
  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();

    if (type === 'payout') {
      // Payout: Two quick beeps (high pitch)
      playBeep(audioContext, 900, 0, 0.15);
      playBeep(audioContext, 900, 0.2, 0.15);
    } else {
      // Payin: Single longer beep (lower pitch)
      playBeep(audioContext, 500, 0, 0.4);
    }
  } catch (error) {
    console.warn('Notification sound error:', error);
  }
}

function playBeep(audioContext, frequency, startTime, duration) {
  const oscillator = audioContext.createOscillator();
  const gainNode = audioContext.createGain();

  oscillator.connect(gainNode);
  gainNode.connect(audioContext.destination);

  oscillator.frequency.value = frequency;
  oscillator.type = 'sine';

  const now = audioContext.currentTime + startTime;
  gainNode.gain.setValueAtTime(1, now);
  gainNode.gain.exponentialRampToValueAtTime(0.01, now + duration);

  oscillator.start(now);
  oscillator.stop(now + duration);
}

 